import { StaticRoutesDE, StaticRoutesEN } from 'constants/navigation';
import { useRouter } from 'next/router';

export const useUrl = () => {
    const { locale } = useRouter();

    switch (locale) {
        case 'en':
            return StaticRoutesEN;
        case 'de':
            return StaticRoutesDE;
        default:
            return StaticRoutesEN;
    }
};
